import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconMapPin, IconSearch } from '@tabler/icons-react'

import bannerHero from '../../static/img/banner_hero.png'

import './styles/hero.css'

function Hero() {

    const navigate = useNavigate();

    const departamentos_peru = ["Amazonas", "Áncash", "Apurímac", "Arequipa", "Ayacucho", "Cajamarca", "Callao", "Cusco", "Huancavelica", "Huánuco", "Ica", "Junín", "La Libertad", "Lambayeque", "Lima", "Loreto", "Madre de Dios", "Moquegua", "Pasco", "Piura", "Puno", "San Martín", "Tacna", "Tumbes", "Ucayali"]

    const [ workEntry, setWorkEntry ] = useState({
        work: '',
        location: '',
    });

    const handleFindWork = () => {
        navigate(`/works/?work=${workEntry.work}&location=${workEntry.location}`)
    }

    return (

        <section className='--hero'>

            <div className='--bg-lan'>

                <div className='--txt-big'>
                    <h1>Encuentra el trabajo adecuado, a tu manera</h1>
                </div>

                <div className='--txt-small'>
                    <p>Únase a la comunidad número uno del mundo especializada en oportunidades y talento técnico remoto y local.</p>
                </div>

                <div className='--textbox'>
                    <div className='--txtbox-1'>
                        <span className='--span-ico'><IconSearch/></span>
                        <input className='--entry' placeholder='Buscar' aria-placeholder='Buscar' aria-label='Buscar' autoComplete='off' onChange={(e) => setWorkEntry({ ...workEntry, work: e.target.value })}/>
                    </div>
                    <div className='--txtbox-1'>
                        <span className='--span-ico'><IconMapPin/></span>
                        <select className='--select' defaultValue={''} onChange={(e) => setWorkEntry({ ...workEntry, location: e.target.value })}>
                            <option value={''} hidden>Ubicación</option>
                            {departamentos_peru.map((departament, i) => (
                                <option value={departament} key={i}>{departament}</option>
                            ))}
                        </select>
                    </div>
                    <button className='--btn-search' onClick={handleFindWork}>Buscar</button>
                </div>

                <div className='--suggestions-marks'>
                    <h4>Con la confianza de</h4>
                    <div className='--line'></div>
                </div>

            </div>

            <img src={bannerHero} alt='La oportunidad de encontrar tu Chambita de ensueño' />

        </section>

    )

}

export default Hero